import { t as resilientLazy } from "./lazy-implementation-8ID6ez-9.js";
import { jsx, jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { Suspense } from "react";
import css from "./ReadBlock.module.css";
//#region lib/types/ReadBlock.js
/** Lightweight read-result facade with a readable raw-text fallback. */
/** Content lines shown before the loaded view collapses its middle. */
const DEFAULT_READ_MAX_LINES = 16;
function PlainReadBlock({ label, labels, lines, totalLines, lang, className, busy = false }) {
	const windowed = lines.length < totalLines;
	const raw = lines.map((line) => `${line.number}\t${line.text}`).join("\n");
	return jsxs("div", {
		className: clsx(css.block, className),
		"data-read": "",
		"aria-busy": busy || void 0,
		children: [jsxs("div", {
			className: css.banner,
			children: [jsx("div", {
				className: css.label,
				children: label ?? ""
			}), jsxs("div", {
				className: css.action,
				children: [windowed && jsx("span", {
					className: css.count,
					children: labels?.window(lines.length, totalLines) ?? `显示 ${lines.length} / ${totalLines} 行`
				}), jsx("span", {
					className: css.lang,
					children: lang ?? ""
				})]
			})]
		}), jsx("pre", {
			className: css.plainFallback,
			children: raw
		})]
	});
}
function ReadBlockUnavailable(props) {
	return jsx(PlainReadBlock, { ...props });
}
const LazyReadBlock = resilientLazy(() => import("./ReadBlockImpl-svrSkJbG.js").then((module) => module.ReadBlockImpl), ReadBlockUnavailable);
/**
* Render a read result without placing its tool-detail behavior or syntax
* highlighter on the initial shell path. Pending and failed implementation
* loads retain line-numbered selectable monospace text.
* @param props - File label, returned lines, total count, language, cap, and placement class.
* @returns The raw facade or loaded interactive read block.
*/
function ReadBlock(props) {
	return jsx(Suspense, {
		fallback: jsx(PlainReadBlock, {
			...props,
			busy: true
		}),
		children: jsx(LazyReadBlock, { ...props })
	});
}
//#endregion
export { ReadBlock as n, DEFAULT_READ_MAX_LINES as t };

//# sourceMappingURL=ReadBlock-tYLCS33F.js.map